import { getUnseenCount } from '@ms/yammer-data/dist/domains/notificationPaginations/selectors';
import { reportUsage } from '@ms/yammer-telemetry';
import { usePrevious } from '@ms/yammer-web-core-ui/dist/util/usePrevious';
import { useEffect } from 'react';

import { useSelector } from './useSelector';

type UseLoadUnseenNotifications = () => void;
export const useReportNotificationsCountEffect: UseLoadUnseenNotifications = () => {
  const unseenNotificationCount = useSelector(getUnseenCount);
  const previousUnseenNotificationCount = usePrevious(unseenNotificationCount);

  useEffect(() => {
    const indicatorShown = unseenNotificationCount > 0 && previousUnseenNotificationCount === 0;

    if (indicatorShown) {
      reportUsage({
        eventName: 'notifications_count_displayed',
        eventProperties: {
          unseenCount: unseenNotificationCount,
        },
      });
    }
  }, [previousUnseenNotificationCount, unseenNotificationCount]);
};
